import DeleteIcon from '@mui/icons-material/Delete'
import { Box, Stack } from '@mui/joy'
import { useStore } from 'effector-react'
import { usePermissions } from '~/entities/viewer'
import { myPalette } from '~/shared/lib/theme'
import { Alert } from '~/shared/ui/Alert'
import { Button, IconButton } from '~/shared/ui/Buttons'
import { CanceledIcon } from '~/shared/ui/Icons'
import { Modal, useModal } from '~/shared/ui/Modal'
import { deleteMassMailingFx, deleteMassMailing } from '../model'

export const DeleteMassMailing = () => {
  const { canMassMailingDelete } = usePermissions()
  const { isModalShow, openModal, closeModal } = useModal()

  const idDeletePostPending = useStore(deleteMassMailingFx.pending)

  const handleDelete = () => {
    deleteMassMailing()
  }

  return (
    <>
      <IconButton
        onClick={openModal}
        tooltipProps={{ title: 'Удалить рассылку?' }}
        show={canMassMailingDelete}
        data-testid='massMailing-delete-button'
      >
        <DeleteIcon sx={{ color: myPalette.red['700'] }} />
      </IconButton>

      <Modal
        isShow={isModalShow}
        onCancel={idDeletePostPending ? undefined : closeModal}
        dialogProps={{
          sx: {
            minWidth: '600px',
            maxWidth: '600px',
          },
        }}
      >
        <Alert variant='info' sx={{ margin: '44px 0 24px 0' }}>
          Удалить рассылку?
        </Alert>

        <Box sx={{ padding: '4px' }}>
          <Stack direction='row' justifyContent='space-between' spacing={2}>
            <Button
              variant='gray'
              onClick={closeModal}
              disabled={idDeletePostPending}
              fullWidth
            >
              Отмена
            </Button>
            <Button
              variant='textRed'
              loading={idDeletePostPending}
              fullWidth
              startDecorator={<CanceledIcon />}
              onClick={handleDelete}
              data-testid='massMailing-delete-button-confirm'
            >
              Удалить
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  )
}
